var map = {
	"./Finnable.png": 8368,
	"./HDB.png": 6365,
	"./cashe.png": 3605,
	"./earlysalary.png": 7396,
	"./homeville.png": 8992,
	"./kreditbee.png": 2014,
	"./l&t.png": 2737,
	"./loantap.png": 8082,
	"./moneyview.png": 6620,
	"./moneywide.png": 7378,
	"./mpokket.png": 5492,
	"./paysense.png": 9207,
	"./subhLife.png": 2991,
	"./upwards.png": 9275,
	"./zype.png": 6529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4064;